import React from 'react';
import { connect } from "react-redux";
import PropTypes from "prop-types";

const FeatureCartItemsCount = (props) => {

  const {currentFeatureId, cartItems, advancedQuotingSearchItem, activeQuoteIndex} = props;

  const getAddedCartItemsCount = () => {
    if (advancedQuotingSearchItem && advancedQuotingSearchItem.cartFeature) {
      if (advancedQuotingSearchItem.cartFeature.dbFeature.id === currentFeatureId) {
        return advancedQuotingSearchItem.quantity
      }
      return 0
    }
    let currentFeatureCartItemsCount = 0;
    const matchingCartItems = cartItems.filter((cartItem) => {
      return (currentFeatureId === cartItem.cartFeature.dbFeature.id) && (cartItem.currentQuote === activeQuoteIndex)
    });
    if (matchingCartItems.length) {
      currentFeatureCartItemsCount = matchingCartItems.reduce((total, cartItem) => {
        if (cartItem.partId === 'slabs') { // do not count slabs QCDES-1730
          return total + 0
        }
        return total + cartItem.quantity
      }, 0)
    }
    return +(+(currentFeatureCartItemsCount).toFixed(3)).toFixed(2)
  }

  const currentFeatureCartItemsCount = getAddedCartItemsCount();
  if (!currentFeatureCartItemsCount) {
    return null
  }

  return (
    <span className="materials-button--cart-length">{currentFeatureCartItemsCount}</span>
  )
};

FeatureCartItemsCount.propTypes = {
  currentFeatureId: PropTypes.number.isRequired,
};

const mapStateToProps = (store) => {
  const {cartItems} = store.cartState;
  const {activeQuoteIndex} = store.quotesState;
  const {advancedQuotingSearchItem} = store.advancedQuotingState;
  return {
    cartItems,
    activeQuoteIndex,
    advancedQuotingSearchItem,
  };
};

export default connect(mapStateToProps)(FeatureCartItemsCount);
